import Immutable from 'immutable'
import { types, allLocales } from 'store/actions/locale'
import LocaleCurrency from 'locale-currency'

const initialState = Immutable.fromJS({
  currency: 'USD',
  locale: 'en-us',
  availableLocales: allLocales,
})

export default function filtersReducer(state = initialState, action) {
  let ret = state
  switch(action.type) {
    case types.SET: {
      const locale = action.payload
      if(!ret.get('availableLocales').includes(locale)) {
        throw new Error('Unsupported locale')
      }
      ret = ret.set('active', locale)
        .set('currency', LocaleCurrency.getCurrency(locale))
      break
    }
    // no default
  }
  return ret
}
